<template >
    <div class="container-fluid" >

        <h3>Та доорх асуултанд хариулна уу</h3>
        
      <div v-if="questions!=null && questions.length>0">
        
      <div  class="card shadow mb-4" v-for="(question, index) in questions" v-bind:key="question.id">
        <div class="card-header py-3">
            <div class="row justify-content-between">
                <div class="col col-12"><h3 class="m-0 font-weight-bold text-primary">{{index+1}}.  {{question.name}}</h3></div>
        
            </div>
          
          <p>{{question.description}}</p>

          <div class="my-4" v-if="question.answers!=null && question.answers.length>0">
            <h6>Хариултууд</h6>
            <ul class="list-group">
              <li v-for="(answer) in question.answers" v-bind:key="answer.id" class="list-group-item" @click="answerQuestion(question, answer)"  v-bind:class="[question.useranswer!=null && question.useranswer.answer!=null && question.useranswer.answer.id==answer.id ? 'answered' : '']">
                <div class="row" > 
                  <div class="col col-12">{{answer.name}}</div>
                  <!-- <div class="col col-2"><span class="badge badge-primary badge-pill">{{answer.votedCount}}</span></div> -->
                </div>
                
              </li>
            </ul>

          </div>
          <div v-else class="alert alert-success">
                Одоогоор энэ асуултанд хариулт оруулаагүй байна.
            </div>
        </div>
        
      </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
 import BarChart from './BarChart.js'
import { stat } from 'fs';
import { usersCollection } from '../firebaseConfig.js';
 var colors=['#000000', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'];
export default {
    name: "Questions",
    components: {
        BarChart
    },
    data() {
        return {
            questions:[],
            
            statData:{
                    chartOptions: {
                        chart: {
                            id: 'basic-bar'
                        },
                        colors: colors,
                        labels:{
                            show:true,
                            hideOverlappingLabels:false
                        },
                        plotOptions: {
                            bar: {
                                distributed: true,
                                horizontal:true,
                                endingShape:'rounded'
                            }
                        }
                        // plotOptions: {
                        //     bar: {
                        //     horizontal: false,
                        //     columnWidth: '55%',
                        //     endingShape: 'rounded'	
                        //     },
                        // },
                    },
                    series: [{
                        name: 'series-1',
                        data: [{
                            x: 'Apple',
                            y: 54
                        }, {
                            x: 'Orange',
                            y: 66
                        }],
                    }]
                },
                
            
        };
    },
    methods: {
        
      _getQA(){
        fb.db.collection("asuulga/"+this.qaId+"/questions").where("public", "==", true).onSnapshot(querySnapshot=> {
            this.questions=[]
            querySnapshot.forEach(doc=> {
             
                let object=doc.data()
                object.id = doc.id
                object.statData=null
                object.datacollection=null
                object.answers=[]
                this._getAnswers(object, doc.ref)
                this._getUserAnswer(object, doc.ref)
                this.questions.push(object);
            });
        
        });
              
    
          

      },
      _getUserAnswer(question, ref){
        if(question.useranswer==null || question.useranswer==undefined)
                question.useranswer=null;
            ref.collection("votedusers").doc(this.$store.getters.currentUser.uid).onSnapshot(doc=> {
                question.useranswer=null;
                if (doc.exists) {
                    question.useranswer=doc.data()
                }

            });  
      },
       _getAnswers(question, ref){
            if(question.answers==null || question.answers==undefined)
                question.answers=[];
            ref.collection("answers").onSnapshot(querySnapshot=> {
                question.answers=[];
                let labels=[]
                let dataset=[
                    {
                        label: 'A',
                        backgroundColor: '#f87979',
                        data: [],
                        backgroundColor:[]
                    }
                ]
                let data=[]
                let index=0;
                let answered=false
                querySnapshot.forEach(doc=> {
                    let answer=doc.data()
                        answer.id = doc.id
                    if(answer.votedCount!=null && answer.votedCount>0)
                      answered=true;
                        labels.push(answer.name)
                        dataset[0].data.push(answer.votedCount);
                        dataset[0].backgroundColor.push(index<=colors.length? colors[index]:this.getRandomColor());
                        data.push({x: answer.name, y: answer.votedCount, color: this.getRandomColor()})

                        question.answers.push(answer);
                        index++
                });
                if(answered==true){
                  question.statData=this.statData
                  question.datacollection={
                      labels: labels,
                      datasets: dataset
                  }
                    // this.statData.chartOptions.xaxis.categories=labels
                    question.statData.series=[{
                        name: 'санал',
                        data: data
                    }]
                }
                else{
                  question.datacollection=null
                  question.statData=null
                }
            });

        },
         getRandomInt () {
            return Math.floor(Math.random() * (50 - 5 + 1)) + 5
        },
        getRandomColor() {
            var letters = '0123456789ABCDEF';
            var color = '#';
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        answerQuestion(question, answer){
            if(question.useranswer==null){
                var questionRef=fb.db.collection("asuulga/"+this.qaId+"/questions").doc(question.id);
                var ref=questionRef.collection("votedusers").doc(this.$store.getters.currentUser.uid)
                var answerRef=questionRef.collection("answers").doc(answer.id)
                ref.set(
                    {
                        user:fb.usersCollection.doc(this.$store.getters.currentUser.uid),
                        userId:this.$store.getters.currentUser.uid,
                        date:new Date(),
                        isCorrect: answer.correct,
                        answer:answerRef, 
                        answerId: answer.id
                    }
                )
                answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)})
                var questionCountRef=fb.db.collection("asuulga/"+this.qaId+"/votedCount").doc(question.id);
                questionCountRef.update({votedCount:fb.firestore.FieldValue.increment(1), questionId:question.id})
            }
        }
       

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },

    props: {
        qaId: { 
            required: true,
        },
       
    
    },
    created() {
      if(this.qaId!=null && this.qaId!=''){
        this._getQA()
      }
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>
<style>
    .answered{
        background-color:#04d142;
        color:white
    }
</style>

